import HealthIcon from "@/assets/svg/palmistry/result/line/health.svg?react"
import SuccessIcon from "@/assets/svg/palmistry/result/line/success.svg?react"
import RomanceIcon from "@/assets/svg/palmistry/result/line/romance.svg?react"
import CareerIcon from "@/assets/svg/palmistry/result/line/career.svg?react"
import ChartCircle from "@/assets/svg/palmistry/result/line/chart-circle.svg?react"

import { chartMeterCopy, type ChartType } from "../config/copy"
import { chartLevel } from "../lib/palm-reading"
import { ArcGauge } from "./arc-gauge"

const icons = { health: HealthIcon, success: SuccessIcon, romance: RomanceIcon, career: CareerIcon }
const levelStyles = {
  low: { badge: "bg-peach/20", text: "text-peach" },
  medium: { badge: "bg-gold/20", text: "text-gold" },
  high: { badge: "bg-green/20", text: "text-green" },
} as const

interface PalmChartMeterProps {
  type: ChartType
  value: number
}

/** Life-area meter (icon + copy on the left, gradient gauge on the right). Ported from ChartMeter. */
export function PalmChartMeter({ type, value }: PalmChartMeterProps) {
  const level = chartLevel(value)
  const Icon = icons[type]
  const copy = chartMeterCopy[type]
  const { badge, text } = levelStyles[level]
  const gradientId = `palmGrad-${type}`

  return (
    <div className="flex items-center justify-between gap-6">
      <div>
        <div className="flex items-center gap-2.5 [&_svg]:size-8">
          <Icon />
          <h4 className="font-display text-2xl font-medium text-purple-light">{copy.title}</h4>
        </div>
        <p className="mt-4 font-body text-base text-purple-light/70">{copy[level].description}</p>
      </div>

      <div className="relative w-[178px] shrink-0">
        <svg width="0" height="0" aria-hidden>
          <defs>
            <linearGradient
              id={gradientId}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
              gradientTransform="rotate(105)"
            >
              <stop offset="0%" stopColor="#FF537F" />
              <stop offset="15%" stopColor="#FF6D4B" />
              <stop offset="50%" stopColor="#FF9B00" />
              <stop offset="65%" stopColor="#DED500" />
              <stop offset="90%" stopColor="#7FE718" />
            </linearGradient>
          </defs>
        </svg>

        <span className="absolute right-0 top-1 [&_svg]:h-[129px] [&_svg]:w-[178px]">
          <ChartCircle />
        </span>

        <div className="relative mx-auto flex justify-center">
          <ArcGauge
            value={value}
            ratio={0.65}
            size={164}
            strokeWidth={11}
            stroke={`url(#${gradientId})`}
          >
            <div className="flex flex-col items-center">
              <p className="font-display text-[36px] font-medium text-purple-light">{value}%</p>
              <span
                className={`rounded-[13px] px-3 py-1.5 font-body text-[10px] font-medium uppercase ${badge} ${text}`}
              >
                {copy[level].label}
              </span>
            </div>
          </ArcGauge>
        </div>
      </div>
    </div>
  )
}
